import StatXHR from './stat-xhr.js';

// Default options for the plugin.
const DEFAULTS = {
	method: "image",
	serverTimeOffset: 0,
	interval: 30,
	intervalStartEvents: ['vast.firstPlay'],
	intervalStopEvents: ['vast.lastPostrollEnd'],
	urlPlaceholders: [{
		name: '[FTS]',
		value: function(ev) {
			return Math.floor((Date.now() + this.serverTimeOffset) / 1000);
		} 
	}, {
		name: '[VTS]',
		value: function(ev) {
			return Math.floor(Date.now() / 1000);
		}
	}, {
		name: '[DEVICE_TYPE]',
		value: function(ev) {
			return this.utils.isMobile() ? 'm' : 'd';
		} 
	}],
	cache: true
};

/**
 * The Stat class to send stat via TNS Heartbeat or using image tag.
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends StatXHR
 */

class StatTNSHeartbeat extends StatXHR {
	constructor(player, options) {
		let options_ = Object.assign({}, DEFAULTS, options);
		options_.urlPlaceholders = (options.urlPlaceholders || []).concat(DEFAULTS.urlPlaceholders);
		super(player, options_);

		this.serverTimeOffset = options_.serverTimeOffset;
	}
}

export default StatTNSHeartbeat;
